import { Grid } from '@mui/material';
import { ReactElement, CSSProperties } from 'react';
import { Item, WsColors } from 'wisestep-base';

import Component from '../component';

interface ComponentProps {
  icon: ReactElement;
}

const commonStyle: CSSProperties = {
  color: WsColors.White,
  fontSize: '30px',
  paddingTop: 0.5,
};
const IconForDialog: React.FC<ComponentProps> = ({ icon }) => (
  <Item
    sx={{
      pl: '45%',
      pr: '45%',
    }}
  >
    <Grid
      bgcolor={WsColors.TheBlues400}
      container
      minHeight={50}
      justifyContent="center"
      alignItems="center"
      borderRadius="50%"
    >
      <Grid item>
        <Component icon={icon} commonStyle={commonStyle} />
      </Grid>
    </Grid>
  </Item>
);

export default IconForDialog;
